import React, { use, useMemo } from "react";
import { AuthManagerContext } from "../contexts/AuthManager";
import { StyleSheet, View, Text } from "react-native";

const ImpersonationBar: React.FC = () => {
    const { user: impersonatedUser } = use(AuthManagerContext);
    const impersonatedBy = useMemo(() => {
        if (!impersonatedUser) {
            return null;
        }
        return impersonatedUser.impersonatedBy;
    }, [impersonatedUser]);

    // Only render the bar if an impersonated user is provided
    if (!impersonatedBy || !impersonatedUser) {
        return null;
    }

    return (
        <View style={styles.barContainer}>
            <Text style={styles.messageText}>
                You are{" "}
                <Text style={styles.boldText}>
                    {impersonatedBy.firstName} {impersonatedBy.lastName}
                </Text>
                , acting as{" "}
                <Text style={styles.boldText}>
                    {impersonatedUser.firstName} {impersonatedUser.lastName}
                </Text>
                .
            </Text>
        </View>
    );
};

const styles = StyleSheet.create({
    barContainer: {
        backgroundColor: "#FFEB3B", // A noticeable yellow background
        paddingVertical: 12,
        paddingHorizontal: 16,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        borderBottomWidth: 1,
        borderBottomColor: "#9CA3AF", // Gray border
        width: "100%",
    },
    messageText: {
        fontSize: 14,
        color: "#4B5563", // Dark gray text for contrast
        textAlign: "center",
    },
    boldText: {
        fontWeight: "bold",
    },
});

export default ImpersonationBar;
